// Beltma — paket kartları + mobil sabit "Sepete ekle" çubuğu.

// Seçilen kart: gizli quantity alanını, seçili görünümü ve sabit çubuktaki fiyatı günceller.
document.addEventListener('change', (event) => {
  const input = event.target.closest('.beltma-qty input[type="radio"]');
  if (!input) return;
  const root = input.closest('.beltma-qty');
  root.querySelectorAll('.beltma-qty__card').forEach((card) => {
    card.classList.toggle('is-selected', card.contains(input));
  });
  const hidden = root.querySelector('[data-beltma-qty-input]');
  if (hidden) hidden.value = input.value;
  const sticky = document.querySelector(`[data-beltma-sticky="${root.dataset.form}"]`);
  const price = sticky && sticky.querySelector('[data-beltma-sticky-price]');
  const card = input.closest('.beltma-qty__card');
  if (price && card) price.textContent = card.dataset.price;
});

// Sabit çubuk: asıl "Sepete ekle" butonu ekranda değilken görünür; dokununca asıl formu gönderir.
function beltmaInitSticky() {
  document.querySelectorAll('[data-beltma-sticky]').forEach((sticky) => {
    if (sticky.dataset.ready) return;
    const form = document.getElementById(sticky.dataset.beltmaSticky);
    const submit = form && form.querySelector('[type="submit"]');
    if (!submit) return;
    sticky.dataset.ready = 'true';
    // Ürün sütunundaki animasyonlu kapsayıcılar position:fixed'i bozmasın diye body'ye taşınır.
    document.body.appendChild(sticky);
    document.body.classList.add('beltma-has-sticky');
    new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-visible', !entry.isIntersecting);
    }).observe(submit);
    sticky.querySelector('[data-beltma-sticky-btn]').addEventListener('click', () => submit.click());
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', beltmaInitSticky);
else beltmaInitSticky();
